import { useQuery } from "@tanstack/react-query";
import { QUERY_CONSTANTS } from "../../queryKeys";
import { IClassEventTimeRange } from "../../../models/ClassEvent";
import { ClassEventService } from "../../../services/class-event.service";

export const useGetTimeRangesForClassesQuery = () => {
  return useQuery<IClassEventTimeRange[], Error>({
    queryKey: [QUERY_CONSTANTS.GET_TIME_RANGES_FOR_CLASSES],
    queryFn: () => ClassEventService.getTimeRangesForClasses().then((res) => res.data),
  });
};
